import { SupernovaExceptionType } from "@supernova-studio/model";

export type RequestExecutorErrorType = "ServerError" | "ResponseParsingError";
export type RequestEexecutorServerErrorCode = SupernovaExceptionType | undefined;

export class RequestExecutorError extends Error {
  readonly type: RequestExecutorErrorType;
  readonly errorCode: RequestEexecutorServerErrorCode | undefined;
  readonly serverErrorType: SupernovaExceptionType | undefined;

  static tryParseErrorCode(body: string) {
    try {
      const errorObj = JSON.parse(body);
      if (errorObj && typeof errorObj.errorCode === "string") {
        return errorObj.errorCode;
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  static tryParseServerErrorType(body: string) {
    try {
      const errorObj = JSON.parse(body);
      if (errorObj && typeof errorObj.errorCode === "string") {
        return errorObj.type;
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  static serverError(endpoint: string, status: number, bodyText: string) {
    return new RequestExecutorError(
      "ServerError",
      `Endpoint ${endpoint} returned ${status}\n${bodyText}`,
      this.tryParseErrorCode(bodyText),
      this.tryParseServerErrorType(bodyText)
    );
  }

  static responseParsingError(endpoint: string, cause: Error) {
    return new RequestExecutorError(
      "ResponseParsingError",
      `Endpoint ${endpoint} returned incompatible JSON`,
      undefined,
      undefined,
      cause
    );
  }

  private constructor(
    type: RequestExecutorErrorType,
    message: string,
    errorCode: RequestEexecutorServerErrorCode | undefined,
    serverErrorType?: SupernovaExceptionType | undefined,
    cause?: unknown
  ) {
    super(`${type}: ${message}`, { cause });
    this.type = type;
    this.errorCode = errorCode;
    this.serverErrorType = serverErrorType;
  }
}
